module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"titleQuestion":"Question :","titleResponse":"Réponse apportée :","titleExpectedResponse":"Réponse attendue :","btnValid":"Valide","btnInvalid":"Invalide"},"en":{"titleQuestion":"Question:","titleResponse":"Answer:","titleExpectedResponse":"Expected answer:","btnValid":"Valid","btnInvalid":"Invalid"}}')
  delete Component.options._Ctor
}
